<template>
  <div class="content">
    <b-container class="settings-page">
      <!-- OKTA Integration Card -->
      <b-card no-body class="mb-4">
        <b-card-header @click="toggleOktaCollapse" class="d-flex justify-content-between align-items-center">
          <span>OKTA Integration</span>
          <b-icon :icon="oktaCollapsed ? 'chevron-down' : 'chevron-up'"></b-icon>
        </b-card-header>
        <b-collapse :visible="!oktaCollapsed" class="mt-2">
          <b-card-body>
            <b-form @submit.prevent="saveOktaSettings">
              <b-form-group label="Enable OKTA Integration" label-for="enableOkta">
                <b-form-checkbox v-model="oktaSettings.enabled" id="enableOkta">
                  Enable OKTA integration for domain
                </b-form-checkbox>
              </b-form-group>

              <b-form-group label="Domain" label-for="oktaDomain">
                <b-form-input
                  v-model="oktaSettings.domain"
                  id="oktaDomain"
                  placeholder="Enter domain (e.g., example.com)"
                  required
                  :disabled="!oktaSettings.enabled"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="OKTA Client ID" label-for="oktaClientId">
                <b-form-input
                  v-model="oktaSettings.clientId"
                  id="oktaClientId"
                  placeholder="Enter OKTA Client ID"
                  required
                  :disabled="!oktaSettings.enabled"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="OKTA Client Secret" label-for="oktaClientSecret">
                <b-form-input
                  v-model="oktaSettings.clientSecret"
                  id="oktaClientSecret"
                  type="password"
                  placeholder="Enter OKTA Client Secret"
                  required
                  :disabled="!oktaSettings.enabled"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="OKTA Organization URL" label-for="oktaOrgUrl">
                <b-form-input
                  v-model="oktaSettings.orgUrl"
                  id="oktaOrgUrl"
                  placeholder="Enter OKTA Organization URL"
                  required
                  :disabled="!oktaSettings.enabled"
                ></b-form-input>
              </b-form-group>

              <div class="text-center">
                <b-button class="btn-fill" type="submit" variant="primary" :disabled="!oktaSettings.enabled">Save
                  Settings
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Additional Settings Cards -->
      <!-- Add other settings cards below as needed -->
    </b-container>
  </div>
</template>

<script>
import apiClient from "@/http";

export default {
  data() {
    return {
      oktaSettings: {
        enabled: false,
        domain: '',
        clientId: '',
        clientSecret: '',
        orgUrl: ''
      },
      user: {
        email: '',
        role: '',
      },
      oktaCollapsed: false, // To control the collapse state of the OKTA card
    };
  },
  methods: {
    async fetchUserDetails() {
      try {
        const response = await apiClient.get('/user');
        this.user.email = response.data.Email;
        this.user.role = response.data.Role;
      } catch (error) {
        console.error('Failed to fetch user details:', error);
      }
    },

    toggleOktaCollapse() {
      this.oktaCollapsed = !this.oktaCollapsed;
    },
    async saveOktaSettings() {
      try {
        const response = await apiClient.post('/organizations/sso/okta', {
          enabled: this.oktaSettings.enabled,
          domain: this.oktaSettings.domain,
          clientId: this.oktaSettings.clientId,
          clientSecret: this.oktaSettings.clientSecret,
          orgUrl: this.oktaSettings.orgUrl
        });
        this.$bvToast.toast("Settings Updated", {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        const errorMessage = error.response && error.response.data ? error.response.data : `Error fetching okta settings`;
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    async fetchOktaSettings() {
      try {
        const response = await apiClient.get('/organizations/sso/okta');
        this.oktaSettings.enabled = response.data.enabled;
        this.oktaSettings.domain = response.data.domain;
        this.oktaSettings.clientId = response.data.clientId;
        this.oktaSettings.clientSecret = response.data.clientSecret;
        this.oktaSettings.orgUrl = response.data.orgUrl;
      } catch (error) {
        const errorMessage = error.response && error.response.data ? error.response.data : `Error fetching okta settings`;
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    }
  },
  mounted() {
    // Load existing OKTA settings when the page is loaded
    this.fetchUserDetails();
    this.fetchOktaSettings();
  }
};
</script>

<style scoped>
.settings-page {
  max-width: 800px;
  margin: 0 auto;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.card-header {
  cursor: pointer;
}
</style>
